import React from 'react';
import { FadeIn } from './FadeIn';
import { TrophyIcon, ArrowUpRightIcon } from 'lucide-react';
export function PremiumUpsell() {
  return <section className="py-16 sm:py-24 px-4 bg-pump-dark relative overflow-hidden" data-id="element-116">
      <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-yellow-500/5 rounded-full blur-[100px] pointer-events-none" data-id="element-117" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-118">
        <FadeIn data-id="element-119">
          <div className="flex items-center justify-center gap-3 mb-8" data-id="element-120">
            <TrophyIcon className="w-8 h-8 text-yellow-400" data-id="element-121" />
            <span className="text-yellow-400 font-bold tracking-widest uppercase" data-id="element-122">
              Para el instructor que quiere ir un nivel más arriba
            </span>
          </div>

          <h2 className="text-3xl sm:text-5xl font-display font-bold text-center text-white mb-10" data-id="element-123">
            Existe una versión del protocolo que incluye el{' '}
            <br className="hidden sm:block" data-id="element-124" />
            <span className="text-yellow-400" data-id="element-125">
              Conjunto Elite: El Instructor Marca Registrada + El Escenario
              Inmortal.
            </span>
          </h2>
        </FadeIn>

        <FadeIn delay={0.1} data-id="element-126">
          <div className="bg-gradient-to-br from-pump-surface to-pump-dark border border-yellow-500/20 p-8 sm:p-10 rounded-3xl shadow-2xl" data-id="element-127">
            <p className="text-lg text-gray-300 leading-relaxed mb-6" data-id="element-128">
              Y esa versión resuelve algo que los 6 tomos no resuelven solos:{' '}
              <strong data-id="element-129">
                la brecha entre ser un excelente instructor técnico y tener una
                carrera que crece, una sala que no para de llenarse y un nombre
                que se reconoce en tu ciudad.
              </strong>
            </p>
            <p className="text-lg text-gray-300 leading-relaxed mb-8" data-id="element-130">
              Porque podés tener la mejor presencia del mundo y seguir cobrando
              lo mismo que hace dos años. Podés tener alumnos fieles y seguir
              sin saber cómo atraer nuevos. Podés tener el mejor cueing de la
              grilla y seguir siendo invisible en Instagram.
            </p>

            <h3 className="text-2xl font-display font-bold text-white mb-6" data-id="element-131">
              Los 6 Upsells de Elite cierran esas brechas.
            </h3>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8" data-id="element-132">
              {[{
              conjunto: 'Conjunto 1 — Marca Registrada',
              items: ['BodyPump Business: El Negocio del Instructor', 'Social Media Domination: Instagram para Instructores', 'El Manual del Coach Premium: Liderazgo y Psicología de Masas']
            }, {
              conjunto: 'Conjunto 2 — El Escenario Inmortal',
              items: ['Advanced Stage Presence: Técnicas de Actuación', 'Retos de 21 Días: Gamificación de Sala', 'Master de Niveles y Adaptaciones: Inclusión de Elite']
            }].map((grupo, gi) => <div key={gi} className="bg-pump-dark/60 border border-pump-muted rounded-xl p-5" data-id="element-133">
                  <p className="text-yellow-400 font-bold text-sm mb-4 uppercase tracking-wider" data-id="element-134">
                    {grupo.conjunto}
                  </p>
                  <ul className="space-y-3" data-id="element-135">
                    {grupo.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-136">
                        <ArrowUpRightIcon className="w-5 h-5 text-yellow-400 shrink-0 mt-0.5" data-id="element-137" />
                        <span className="text-gray-300 text-sm" data-id="element-138">{item}</span>
                      </li>)}
                  </ul>
                </div>)}
            </div>

            <div className="bg-yellow-500/10 border border-yellow-500/20 p-4 rounded-xl text-center" data-id="element-139">
              <p className="text-yellow-400 font-medium" data-id="element-140">
                No es para todos. Es para el instructor que ya quiere que su
                talento se convierta en una carrera real, rentable e
                inolvidable.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}